import styled from "@emotion/styled";

const StepContainer = styled.header`
  display: flex;
  justify-content: space-between;
  max-width: ${props => props.maxWidth}px;
  width: 100%;
  margin: 0 auto 40px auto;
  position: relative;
`;

const Step = styled.button`
  position: relative;
  width: 36px;
  height: 36px;
  transform: ${({completed}) => (completed ? 'scale(.7)' : 'scale(1)')};
  cursor: ${({completed}) => (completed ? 'pointer' : 'inherit')};
  border-radius: 50%;
  border: ${({completed, active}) => (completed ? '0' : active ? '2px solid' : '1px solid')};
  border-color: ${({active, theme}) => (active ? theme.highlightColor : theme.secondaryColor)};
  background-color: ${({completed, theme}) => (completed ? theme.highlightColor : theme.backgroundColor)};
  color: ${({active, theme}) => (active ? theme.highlightColor : theme.secondaryColor)};
  font-family: ${({theme}) => theme.fontFamily};
  font-size: 16px;
  font-weight: 700;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  box-sizing: border-box;
  overflow: visible;
  svg {
    position: absolute;
    width: 14px;
    height: 14px;
    top: 12px;
    left: 12px;
  }
  ::after {
    content: '';
    position: absolute;
    top: 50%;
    left: ${({completed, active}) => (completed ? '100%' : active ? 'calc(100% + 2px)' : 'calc(100% + 1px)')};
    width: ${({completed}) => (completed ? '70px' : '42px')};
    height: ${({completed}) => (completed ? '2px' : '1px')};
    background: ${({completed, theme}) => (completed ? theme.highlightColor : theme.secondaryColor)};
    z-index: -1;
    display: block;
  }
  
  @media ${({ theme }) => theme.mobile } {
     background-color: ${({completed, theme}) => (completed ? theme.highlightColor : theme.cardColor)};
  }
`;

const SVGContainer = styled.div`
  width: 28px;
  height: 36px;
  z-index: 1;
  background: ${({theme}) => theme.backgroundColor};

  svg {
    display: block;
    fill: ${({active, theme}) => (active ? theme.highlightColor : theme.secondaryColor)};
    height: 100%;
    width: auto;
    z-index: 1;
  }

  @media ${({ theme }) => theme.mobile } {
     background: ${({theme}) => theme.cardColor};
  }
`;

export {
  Step,
  StepContainer,
  SVGContainer
};
